<template>
    <div>
        <table class="table">
            <tr>
                <th></th>
                <th>id</th>
                <th>time</th>
                <th>match_clock</th>
                <th>period</th>
                <th>type</th>
                <th>team</th>
                <th>position</th>
                <th>player</th>
            </tr>
            <tr v-for="(item, index) in timeline" :key="item.id">
                <td>{{ index }}</td>
                <td>{{ item.id }}</td>
                <td>{{ item.time }}</td>
                <td>{{ item.match_clock }}</td>
                <td>
                    <span v-if="item.match_time">match_time: {{ item.match_time }}<br></span>
                    <span v-if="item.period">period: {{ item.period }}<br></span>
                    <span v-if="item.period_name">period_name: {{ item.period_name }}<br></span>
                    <span v-if="item.period_type">period_type: {{ item.period_type }}<br></span>
                    <span v-if="item.injury_time_announced">injury_time_announced: {{ item.injury_time_announced }}<br></span>
                    <span v-if="item.stoppage_time">stoppage_time: {{ item.stoppage_time }}<br></span>
                </td>
                <td>{{ item.type }}</td>
                <td>{{ item.competitor }}</td>
                <td>
                    <span v-if="item.x">x: {{ item.x }}<br></span>
                    <span v-if="item.y">y: {{ item.y }}<br></span>
                </td>
                <td>
                    <div v-if="item.players">
                         <div v-for="player in item.players" :key="player.id">
                            name: {{ player.name }}<br>
                            id: {{ player.id }}<br>
                            <br>
                         </div>
                    </div>

                    <div v-if="item.goal_scorer">
                        <b>goal_scorer</b><br>
                        name: {{ item.goal_scorer.name }}<br>
                        id: {{ item.goal_scorer.id }}
                    </div>

                    <div v-if="item.assist">
                        <b>assist</b><br>
                        name: {{ item.assist.name }}<br>
                        id: {{ item.assist.id }}
                    </div>

                    <div v-if="item.player_in">
                        <b>player_in</b><br>
                        name: {{ item.player_in.name }}<br>
                        id: {{ item.player_in.id }}
                    </div>

                    <div v-if="item.player_out">
                        <b>player_out</b><br>
                        name: {{ item.player_out.name }}<br>
                        id: {{ item.player_out.id }}
                    </div>
                </td>
            </tr>
        </table>
    </div>
    
</template>

<script>
export default {
    name: 'SoccerScoresMatchTimeline',
    props: {
        timeline: ''
    }
}
</script>

